import { APP_VERSION, BUILD_SHA, BUILD_TIME } from '@/lib/version';

// Le SHA git n'est dispo qu'en build local (Easypanel ne fournit pas .git) :
// on n'affiche le commit que s'il est réel, jamais le placeholder "dev".
const showSha = BUILD_SHA && BUILD_SHA !== 'dev';

export function Footer() {
  return (
    <footer className="border-t bg-background/80 px-4 py-2 text-[11px] text-muted-foreground">
      <div className="mx-auto flex max-w-screen-2xl flex-wrap items-center justify-between gap-2">
        <span>MAESTRO · Cockpit AKAZ</span>
        <span className="font-mono">
          v{APP_VERSION}
          {showSha && <> · <span title="Commit">{BUILD_SHA}</span></>}
          {BUILD_TIME && <> · <span title="Build">{BUILD_TIME}</span></>}
        </span>
      </div>
    </footer>
  );
}
